import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { useDrop } from 'react-dnd';

function ConnectedDropBoxPlayer({ accept, drop, opacityLevel = 1, zIndex = 100, style, dimension, isAutomix }) {
  const { playerCoordinates } = dimension;
  const [{ canDrop, isOver }, refDrop] = useDrop({
    accept,
    drop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })
  const opacity = (isOver) ? opacityLevel : 0;
  if (playerCoordinates && playerCoordinates.playerID && !isAutomix) {
    if (document.getElementById(`left-drawer`)) {
      document.getElementById(playerCoordinates.playerID).style[`z-index`] = (canDrop) ? 5 : 80;
    }
  }

  return <div ref={refDrop} style={{...style, opacity, cursor: (canDrop) ? `copy` : `default`, zIndex: (canDrop && !isAutomix) ? 2000 : zIndex}} />
}

ConnectedDropBoxPlayer.propTypes = {
  accept: PropTypes.any.isRequired,
  drop: PropTypes.func.isRequired,
  opacityLevel: PropTypes.number,
  style: PropTypes.object
}

const DropBoxPlayer = connect(
  state => ({
    dimension: state.dimension,
    isAutomix: !!state.uidAutomix
  })
)(ConnectedDropBoxPlayer);

export default DropBoxPlayer;
